import { CiType } from 'src/app/shared/enums/ci-type.enum';
import { QuotationCommercialItem } from '../../models/quotable-items/quotation-commercial-item.model';


export default class QuotationDetailsHelper {
  static sortQuotableItems(data: QuotationCommercialItem) {
    const sg = this.mapSubgroups(data);
    const cp = this.mapCustomerPackages(data);
    const tests = this.mapTests(data);
    const packages = this.mapPackages(data);
    const quotableItems = sg.concat(cp).concat(tests).concat(packages);
    return quotableItems.sort((a, b) => {
      let result: number;
      if (a.sortIndex === b.sortIndex) {
        const aType = a.ciType;
        const bType = b.ciType;
        if (aType === CiType.Subgroup && (bType === CiType.Test || bType === CiType.Package)) {
          result = 1;
        } else if (bType === CiType.Subgroup && (aType === CiType.Test || aType === CiType.Package)) {
          result = -1;
        } else if ((aType === CiType.Subgroup && bType === CiType.Subgroup) ||
          (aType === CiType.Test || aType === CiType.Package) && (bType === CiType.Test || bType === CiType.Package)) {
          result = a.code > b.code ? 1 : -1;
        }
      } else {
        result = a.sortIndex - b.sortIndex;
      }
      return result;
    });
  }
  static mapTests(data: QuotationCommercialItem) {
    return data.freeQuotationLinesTest?.filter(c => !c.isStructuringQuotationLine)?.map(c => {
      return {
        code: c.testCode,
        name: c.text,
        sortIndex: c.sortIndex,
        ciType: CiType.Test
      };
    });
  }
  static mapPackages(data: QuotationCommercialItem) {
    return data.freeQuotationLinesPackage?.filter(c => !c.isStructuringQuotationLine)?.map(c => {
      return {
        code: c.packageCode,
        name: c.text,
        sortIndex: c.sortIndex,
        ciType: CiType.Package
      };
    });
  }
  static mapSubgroups(data: QuotationCommercialItem) {
    return data.commercialItemSubGroups.map(c => {
      return {
        code: c.comlimsCode,
        name: c.name,
        sortIndex: c.sortIndex,
        ciType: CiType.Subgroup
      };
    });
  }
  static mapCustomerPackages(data: QuotationCommercialItem) {
    return data.customerPackages.map(c => {
      return {
        code: c.comlimsCode,
        name: c.name,
        sortIndex: c.sortIndex,
        ciType: CiType.Subgroup
      };
    });
  }
}

